/*
This module most likely will be extracted into ak-react-utils
as soon as other consumers need it...
*/
import React, {createContext} from 'react'

const ImageUrlSigningContext = createContext({})

const ImageUrlSigningProvider = ({imageUrlSigner, children}) => {
  return (
    <ImageUrlSigningContext.Provider value={{ urlSigner: imageUrlSigner }}>
      {children}
    </ImageUrlSigningContext.Provider>
  )
}

export {
  ImageUrlSigningContext,
  ImageUrlSigningProvider
}
